import React, { useCallback } from "react";
import { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { useUser } from "../../../hooks/use-user";
import { errorToast } from "../../../utils/toast";
import axios from "../../../axios";
import { FaArrowRightLong } from "react-icons/fa6";
import Correct from "../../../Images/Vector.png";
import bgImage from "../../../Images/Section (2).png";
import Info from "../../../Images/ph_info-duotone.png";
import Table from "../../../componant/Table/Table";
import Cell from "../../../componant/Table/cell";
import UserTableControls from "./components/UserTableControls";
import UserNameLink from "./components/UserNameLink";
import { useUserTable, userSorters, userSortOptions } from "./hooks/useUserTable";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  InputGroup,
  InputLeftElement,
  Input,
  Button,
  InputRightAddon,
  useDisclosure,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from '@chakra-ui/react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
 ModalBody,
  ModalFooter,
  ModalCloseButton,
  Textarea,
} from "@chakra-ui/react";

import { MdEdit, MdDelete } from "react-icons/md";
import { HiStatusOnline } from "react-icons/hi";
import { GrOverview,GrView } from "react-icons/gr";
import { toast } from "react-toastify";

function DemoUser() {
  const [data, setData] = useState([]);
  const [newID, setNewID] = useState(null);
  const [allUsers, setAllUsers] = useState([]);
const [onHoldUsers, setOnHoldUsers] = useState([]);
const [terminatedUsers, setTerminatedUsers] = useState([]);
const [deletedUsers, setDeletedUsers] = useState([]);
const [activeTab, setActiveTab] = useState("onHold");
const [selectedStatusUser, setSelectedStatusUser] = useState(null);
const [statusAction, setStatusAction] = useState("onHold");
const [selectedUser, setSelectedUser] = useState(null);
const [currentPlan, setCurrentPlan] = useState("");
const [statusMessageEng, setStatusMessageEng] = useState("");
const [statusMessageHindi, setStatusMessageHindi] = useState("");
const [statusUpdateLoading, setStatusUpdateLoading] = useState(false);
const [selectedContest, setSelectedContest] = useState("");
const [totalUsers, setTotalUsers] = useState(0);
 const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [filterType, setFilterType] = useState("");
  const [users, setUsers] = useState([]);
const [stats, setStats] = useState({
  allUsers: 0,
  activeUsers: 0,
  newUsers: 0,
});
  console.log(data);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();
  const {
    isOpen: isContestOpen,
    onOpen: onContestOpen,
    onClose: onContestClose,
  } = useDisclosure();
  const {
  isOpen: isPlanOpen,
  onOpen: onPlanOpen,
  onClose: onPlanClose,
} = useDisclosure();
  const {
    isOpen: isStatusOpen,
    onOpen: onStatusOpen,
    onClose: onStatusClose,
  } = useDisclosure();
  const cancelRef = React.useRef();
  const btnRef = React.useRef()
  const table = useUserTable({
    data,
    searchFields: ["name", "email", "mobile"],
    sorters: userSorters,
    pageSize: 10,
  });

const PAGE_SIZE = 25;
const refreshAccountStatusUsers = useCallback(async (nextActiveTab = "onHold") => {
    try {
      console.log("Fetching on-hold/terminated users...");

      const allUsersRes = await axios.get("getAllUsers");
      const result = allUsersRes?.data?.result || {};
      console.log(result, allUsersRes, "onhold users result");

      const deletedUsersRes = await axios
        .get("/deleted-users")
        .catch((err) => {
          console.error("deleted-users api failed", err);
          return { data: { result: [] } };
        });

      const nextOnHoldUsers = result.onHoldUsers || [];
      const nextTerminatedUsers = result.terminatedUsers || [];
      const nextDeletedUsers = deletedUsersRes.data.result || [];

      // setAllUsers(result.users || []);
      setOnHoldUsers(nextOnHoldUsers);
      setTerminatedUsers(nextTerminatedUsers);
      setDeletedUsers(nextDeletedUsers);

      const tabData = {
        onHold: nextOnHoldUsers,
        terminated: nextTerminatedUsers,
        deleted: nextDeletedUsers,
      };

      setData(tabData[nextActiveTab] || nextOnHoldUsers);
      // setData(result.users || []);
    } catch (err) {
      console.error("getAllUsers api failed", err);
      errorToast("Failed to fetch on-hold users");
    }
}, []);

useEffect(() => {
  refreshAccountStatusUsers("onHold");
}, [refreshAccountStatusUsers]);

const handleTabChange = (tab) => {
  setActiveTab(tab);

  switch (tab) {
    case "onHold":
      setData(onHoldUsers);
      break;

    case "terminated":
      setData(terminatedUsers);
      break;

    case "deleted":
      setData(deletedUsers);
      break;

    default:
      setData([]);
  }
};

const fetchUsers = useCallback(async (type, pageNo = 1) => {
  try {
    let url = "";

    const params = new URLSearchParams({
      page: pageNo,
      // limit: PAGE_SIZE,
      query: search,
      sortBy,
      filterType,
      contestId: selectedContest,
    });

    if (type === "all")
      url = `getAllUsers?${params.toString()}`;

    if (type === "paid")
      url = `getPaidUsers?${params.toString()}`;

    if (type === "demo")
      url = `getDemoUsers?${params.toString()}`;

    const res = await axios.get(url);
    const result = res?.data?.result;
    const userList = result?.users || result || [];

    setUsers(Array.isArray(userList) ? userList : []);
    const total = result?.totalUsers ?? userList?.length ?? 0;
    setTotalUsers(total);

    setStats((previousStats) => ({
      ...previousStats,
      ...(type === "all" && { allUsers: total }),
      ...(type === "paid" && { activeUsers: total }),
      ...(type === "demo" && { newUsers: total }),
    }));
  } catch (err) {
    errorToast("Failed to fetch users");
  }
}, []);
const handleUpdateUserStatus = async () => {
  if (!selectedStatusUser) {
    return errorToast("No user selected for status update");
  }

  try {
    setStatusUpdateLoading(true);

    const payload = {
  userId: selectedStatusUser._id,
  userMessageEng: statusMessageEng,
  userMessageHindi: statusMessageHindi,

  onHold: statusAction === "onHold"
    ? !selectedStatusUser.onHold
    : false,

  terminateUser: statusAction === "terminate"
    ? !selectedStatusUser.terminateUser
    : false,
};
//     if (statusAction === "onHold") {
//   payload.onHold = true;
// } else if (statusAction === "terminate") {
//   payload.terminateUser = true;
// }

    const res = await axios.put("/updateUserAccountStatus", payload);

    toast(res.data.message || "Status updated successfully");
    onStatusClose();
    setStatusAction("onHold");
    setStatusMessageEng("");
    setStatusMessageHindi("");
    setSelectedStatusUser(null);
    refreshAccountStatusUsers(activeTab);
  } catch (err) {
    errorToast(
      err?.response?.data?.message || "Failed to update user status"
    );
  } finally {
    setStatusUpdateLoading(false);
  }
};

const openStatusModal = (user, action) => {
  setSelectedStatusUser(user);
  setStatusAction(action);
  setStatusMessageEng(user.userMessageEng || "");
  setStatusMessageHindi(user.userMessageHindi || "");
  onStatusOpen();
};
  const columns = React.useMemo(
    () => [
      {
        Header: "Sr No.",
        accessor: "srNo",
        Cell: ({ value, row: { index } }) => <Cell text={index + 1} />,
      },
      {
        Header: "User",
        accessor: "name",
        Cell: ({ value, row: { original } }) => (
          <>
            <UserNameLink
              userId={original?._id}
              name={value}
              planName={original?.planName}
              email={original?.email}
            />
            <div className="flex items-center justify-center gap-2 text-13 mt-2">
              <div className="flex gap-2 ">
                <div className="flex justify-center items-center gap-2">
                  <div className="w-10 bg-green-600 rounded-full p-1 h-1 "></div>
                  <h1 className="text-md font-bold text-green">
                    {original?.quizStats?.totalRight}
                  </h1>
                </div>
                <div className="flex justify-center items-center gap-2">
                  <div className="w-10 bg-redC rounded-full p-1 h-1 "></div>
                  <h1 className="text-md font-bold text-red">
                    {original?.quizStats?.totalWrong}
                  </h1>
                </div>
                <div className="flex justify-center items-center gap-2">
                  <div className="w-10 bg-yellow-400 rounded-full p-1 h-1 "></div>
                  <h1 className="text-md font-bold text-yellow-500">
                    {original?.quizStats?.totalSkipped}
                  </h1>
                </div>
              </div>
              {/* <div className="py-1 shadow-md px-2 bg-bgWhite text-black border-1 border-coolGray rounded-lg flex flex-col-2 gap-2 items-center justify-items-center">
                <Image
                  alt="Rate"
                  src={rateIcon}
                  width={20}
                  height={20}
                  layout="fixed"
                />

                <div className="text-center">
                  {original?.planName === "Silver"
                    ? 3000
                    : original?.planName === "Silver Plus"
                    ? 2000
                    : original?.planName === "Gold"
                    ? 1500
                    : original?.planName === "Platinum"
                    ? 1000
                    : 3000}
                  /1$
                </div>
              </div> */}
            </div>
          </>
        ),
      },

      {
        Header: "Ammount Paid",
        accessor: "amount",
        Cell: ({ value, row: { original } }) => (
          <>
            <Cell text={`Rs. ${value}`} />
          </>
        ),
      },
      {
        Header: "Remaining Balance",
        accessor: "remaining",
        Cell: ({ value, row: { original } }) => (
          <>
            <Cell text={`Rs. ${Math.ceil(value)}`} />
          </>
        ),
      },
      // {
      //   Header: "PaymentMethod",
      //   accessor: "paymentMethod",
      //   Cell: ({ value, row: { original } }) => (
      //     <>
      //       <Cell text={value==null?"Other":`${value}`} />
      //     </>
      //   ),
      // },
      {
        Header: "Platform",
        accessor: "platform",
        Cell: ({ value, row: { original } }) => <Cell text={value} />,
      },

      {
        Header: "Created On",
        accessor: "createdOn",
        Cell: ({ value, row: { original } }) => (
          <Cell text={dayjs(value).format("D MMM, YYYY h:mm A")} />
        ),
      },
      {
        Header: "Total Earning (Rs)",
        accessor: "totalEarning",
        Cell: ({ value, row: { original } }) => (
          <Cell text={`Rs. ${Math.ceil(value)}`} />
        ),
      },
      {
        Header: "Wallet Balance (Rs.)",
        accessor: "currentEarning",
        Cell: ({
          value,
          row: {
            original: { rate, quizStats },
          },
        }) => {
          return <Cell text={`Rs. ${Math.round((quizStats?.totalRight || 0) * rate)}`} />;
        },
      },
      {
             Header: "Action",
             accessor: "",
             Cell: ({ value, row: { original } }) => {
               return (
                 <>
                   <Menu>
                     <MenuButton
                       as={Button}
                       className="bg-purple "
                       colorScheme="bgBlue"
                       onClick={() => setNewID(original._id)}
                     >
                       Actions
                     </MenuButton>
                     <MenuList>
                       <Link to={`/dash/view-user/${original._id}`}>
                         <MenuItem>
                           {" "}
                           <GrView className="mr-4" /> View
                         </MenuItem>
                       </Link>
                       <Link to={`/dash/edit-user/${original._id}`}>
                         <MenuItem>
                           {" "}
                           <MdEdit className="mr-4" /> Edit
                         </MenuItem>
                       </Link>
     
                     <MenuItem onClick={() => openStatusModal(original, "onHold")}>
  <HiStatusOnline className="mr-4" />
  Hold User
</MenuItem>

<MenuItem onClick={() => openStatusModal(original, "terminate")}>
  <MdDelete className="mr-4" />
  Terminate User
</MenuItem>
     
                      <MenuItem
                        onClick={() => {
                          setSelectedUser(original);
                          onContestOpen();
                        }}
                      >
                        {/* <MdWhatsapp className="mr-4"/> send Contest Message */}
                      </MenuItem>
                     <MenuItem
       onClick={() => {
         setSelectedUser(original._id);
         setCurrentPlan(original.plan);
         onPlanOpen();
       }}
     >
       <GrOverview className="mr-4" />
       Change Plan
     </MenuItem>
     <MenuItem
       color="red.500"
       onClick={() => {
         setSelectedUser(original._id);
         onOpen(); // Delete confirmation modal
       }}
     >
       <MdDelete className="mr-4" />
       Delete User
     </MenuItem>
                     </MenuList>
                   </Menu>
                 </>
               );
             },
           },
    
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data]
  );

  return (
    <div
      className="lg:py-8 py-4 bg-bgWhite"
      // style={{
      //   backgroundImage: `url('${bgImage}')`,
      //   backgroundSize: "cover",
      //   backgroundRepeat: "no-repeat",
      //   backgroundPosition: "center",
      // }}
    >
      <section class=" md:p-1 ">
        <div class="py-4 ">
          <div class="flex  justify-between items-center">
            <div className="flex items-center gap-3">

  {/* <button
    onClick={() => handleTabChange("all")}
    className={`px-5 py-2 rounded-lg font-medium transition ${
      activeTab === "all"
        ? "bg-purple-600 text-white"
        : "bg-gray-100 text-gray-700"
    }`}
  >
    All Users ({allUsers.length})
  </button> */}

  <button
    onClick={() => handleTabChange("onHold")}
    className={`px-5 py-2 rounded-lg font-medium transition ${
      activeTab === "onHold"
        ? "bg-orange-500 text-white"
        : "bg-gray-100 text-gray-700"
    }`}
  >
    On Hold ({onHoldUsers.length})
  </button>

  <button
    onClick={() => handleTabChange("terminated")}
    className={`px-5 py-2 rounded-lg font-medium transition ${
      activeTab === "terminated"
        ? "bg-red-600 text-white"
        : "bg-gray-100 text-gray-700"
    }`}
  >
    Terminated ({terminatedUsers.length})
  </button>
  <button
  onClick={() => handleTabChange("deleted")}
  className={`px-5 py-2 rounded-lg font-medium transition ${
    activeTab === "deleted"
      ? "bg-gray-700 text-white"
      : "bg-gray-100 text-gray-700"
  }`}
>
  Deleted ({deletedUsers.length})
</button>

</div>
            <UserTableControls
              search={table.search}
              onSearchChange={table.setSearch}
              sortOptions={userSortOptions}
              onSortChange={table.setSortBy}
              showFilter
              filterButtonRef={btnRef}
              onFilterOpen={onOpen2}
            />
            <Drawer
        isOpen={isOpen2}
        placement='right'
        onClose={onClose2}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Create your account</DrawerHeader>

          <DrawerBody>
            <Input placeholder='Type here...' />
          </DrawerBody>

          <DrawerFooter>
            <Button variant='outline' mr={3} onClick={onClose2}>
              Cancel
            </Button>
            <Button colorScheme='blue'>Save</Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
          </div>
          <div className="mt-2">
            <Table
              // isLoading={isLoading}
              data={table.paginatedData || []}
              columns={columns}
              total={table.total}
              pageSize={table.pageSize}
              currentPage={table.page}
              onPageChange={table.setPage}
            />
          </div>
        </div>
      </section>
      <Modal isOpen={isStatusOpen} onClose={onStatusClose} isCentered size="md">
        <ModalOverlay />
        <ModalContent>
         <ModalHeader>
        {statusAction === "terminate"
          ? selectedStatusUser?.terminateUser
            ? "Remove User Termination"
            : "Terminate User"
          : selectedStatusUser?.onHold
            ? "Remove Hold"
            : "Hold User"}
      </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <div className="space-y-4">
              <div>
                <p className="font-semibold">Selected User</p>
                <p>{selectedStatusUser?.name || selectedStatusUser || "-"}</p>
              </div>
      
              <div>
                <label className="font-semibold block mb-2">
                  English Message
                </label>
                <Textarea
                  placeholder="Enter message in English"
                  value={statusMessageEng}
                  onChange={(e) => setStatusMessageEng(e.target.value)}
                  rows={4}
                />
              </div>
      
              <div>
                <label className="font-semibold block mb-2">
                  Hindi Message
                </label>
                <Textarea
                  placeholder="Enter message in Hindi"
                  value={statusMessageHindi}
                  onChange={(e) => setStatusMessageHindi(e.target.value)}
                  rows={4}
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button mr={3} onClick={onStatusClose}>
              Cancel
            </Button>
          <Button
        colorScheme={statusAction === "terminate" ? "red" : "yellow"}
        isLoading={statusUpdateLoading}
        onClick={handleUpdateUserStatus}
      >
        {statusAction === "terminate"
          ? selectedStatusUser?.terminateUser
            ? "Remove Termination"
            : "Terminate User"
          : selectedStatusUser?.onHold
            ? "Remove Hold"
            : "Put On Hold"}
      </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
}

export default DemoUser;
